import { Provider } from "react-redux";
import store from "store";
import { HashRouter, Routes, Route } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { ErrorBoundary } from "vino/core";
import { Settings } from "./components";

function App() {
	return (
		<HashRouter>
			<ErrorBoundary>
				<SnackbarProvider>
					<Provider store={store}>
						<Routes>
							<Route path="/" element={<Settings />} />
						</Routes>
					</Provider>
				</SnackbarProvider>
			</ErrorBoundary>
		</HashRouter>
	);
}
export default App;
